const configureApi = (API) => {
  // Request Interceptor which handles token refresh pre and post token expiry
  API.interceptors.request.use(
    (config) => {
      const accessToken = "getAccessToken()";
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  const responseSuccessHandler = (response) => {
    return response.data;
  };
  API.interceptors.response.use((response) => responseSuccessHandler(response));

  return API;
};

// Todo
export const getAccessToken = () => {
  return JSON.parse(localStorage.getItem("access-token")).accessToken
    ?.accessToken;
};
export default configureApi;
